import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import ArrowDropUp from '@material-ui/icons/ArrowDropUp';
import ArrowDropDown from '@material-ui/icons/ArrowDropDown';
import assign from 'lodash/assign';


const stepperButtonStyle = {
  padding: 0,
  width: 26,
  height: 26,
  minWidth: 0,
  marginRight: 8,
  fontSize: 0.5,
}

const stepperUpStyle = assign({
  borderBottomLeftRadius: 0,
  borderBottomRightRadius: 0,
}, stepperButtonStyle)


const stepperDownStyle = assign({
  marginTop: -1,
  borderTopLeftRadius: 0,
  borderTopRightRadius: 0,
}, stepperButtonStyle)


const NON_NUMBERS_REGEX = /[^0-9]/g


class NumberField extends React.Component {

  handleIncrease = () => {
    if (!this.canIncrease()) return
    this.changeValue(this.props.value + 1)
  }


  handleDecrease = () => {
    if (!this.canDecrease()) return
    this.changeValue(this.props.value - 1)
  }


  handleChange = (val) => {
    val = val.replace(NON_NUMBERS_REGEX, '')
    while(val[0] === '0') val = val.substr(1)
    if (!val) val = '0'

    var num = parseInt(val, 10)
    if (num > 999) val = 999
    this.changeValue(num)
  }


  changeValue = (newVal)  => {
    if (typeof this.props.onChange === 'function') {
      this.props.onChange(newVal)
    }
  }


  canIncrease = () => {
    if (isNaN(this.props.max)) return true
    return this.props.value < parseFloat(this.props.max)
  }


  canDecrease = () => {
    if (isNaN(this.props.min)) return true
    return this.props.value > parseFloat(this.props.min)
  }


  render = () => {

    const width = this.props.width || 60;

    return (
      <React.Fragment>

        <TextField
          type="text"
          inputProps={{ style: {textAlign: 'center'} }}
          style={{ width: width }}
          {...this.props}
          value={this.props.value}
          onChange={e => this.handleChange(e.target.value)}
        />

        <div style={{flexDirection: 'column', display: 'flex'}}>
          <Button style={stepperUpStyle} onClick={this.handleIncrease} variant="outlined" color="default" aria-label="Increase" disabled={!this.canIncrease()}>
            <ArrowDropUp/>
          </Button>
          <Button style={stepperDownStyle} onClick={this.handleDecrease} variant="outlined" color="default" aria-label="Decrease" disabled={!this.canDecrease()}>
            <ArrowDropDown/>
          </Button>
        </div>

      </React.Fragment>
    )
  }

}

NumberField.propTypes = {
  min: PropTypes.number,
  max: PropTypes.number,
  value: PropTypes.number,
  onChange: PropTypes.func,
};


export default NumberField;
